import React, { MouseEventHandler, ReactNode } from 'react'
import { StyledButtonAsLink } from '@components/ui/Button/StyledButtonAsLink'
import { Icon, IconProps } from '@components/ui/Icon'
import { StyledIconButtonAsLink } from './IconButtonAsLink.style'

interface IconButtonAsLinkProps {
  icon: IconProps['name']
  iconPosition?: 'left' | 'right'
  underline?: boolean
  disabled?: boolean
  onClick?: MouseEventHandler
  children?: string | ReactNode
}

export const IconButtonAsLink: React.FC<IconButtonAsLinkProps> = props => {
  const { icon, iconPosition = 'left', underline, onClick, children, ...rest } = props
  return (
    <StyledIconButtonAsLink className="IconButtonAsLink-root" underline={underline} onClick={onClick} {...rest}>
      {iconPosition === 'left' && <Icon name={icon} marginRight={!!children} sx={{ alignSelf: 'center' }} />}
      <StyledButtonAsLink underline={underline} sx={{ textAlign: iconPosition }}>
        {children && children}
      </StyledButtonAsLink>
      {iconPosition === 'right' && <Icon name={icon} marginLeft={!!children} sx={{ alignSelf: 'center' }} />}
    </StyledIconButtonAsLink>
  )
}
